import React, { useContext } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import { useNavigate, useLocation } from 'react-router-dom';
import { ModeContext } from './ModeContext';

// ホームボタン：設定画面以外で表示し、チャット画面（/）に遷移する
const ButtonHome = () => {
  const { setDisplayMode, setIsUploadMode, setActiveButton } = useContext(ModeContext);
  const navigate = useNavigate();
  const location = useLocation();

  // 設定画面では非表示
  if (location.pathname === '/settings') {
    return null;
  }

  const handleHomeClick = () => {
    // チャット画面に戻る際の状態設定
    setDisplayMode('chat');
    setIsUploadMode(false);
    setActiveButton('chat');
    navigate('/');
  };

  return (
    <Tooltip title="ホーム">
      <IconButton
        onClick={handleHomeClick}
        color="inherit"
        sx={{
          bgcolor: "#777777",
          color: "white",
          borderRadius: "50%",
          width: "32px",
          height: "32px",
        }}
      >
        <HomeIcon />
      </IconButton>
    </Tooltip>
  );
};

export default ButtonHome;
